import AppConstants from '../../../../constants/AppConstants';

export const actions = {
    clear() {
        return {
            type: AppConstants.STATISTICS_CHART_CLEAR
        };
    },
};
